import { InterfacePlatform, InterfacePlatformChange } from '../../interface/platform/interface.platform';

export class DownloadPlatformPageService {

  constructor(
    private loader: HTMLElement | null,
  ) {}

  async getPlatform(
    platformId: number | null,
  ): Promise<InterfacePlatform | null> {
    this.loader?.classList.add('active');
    try {
      const response = await fetch(
        `/api/platform-item/${platformId}`, {
          method: 'GET',
          headers: {
            'Authorization': 'true'
          },
        });
      const data: any = await response.json();
      this.loader?.classList.remove('active');
      return data;

    } catch (error) {
      this.loader?.classList.remove('active');

      return null;
    }
  }
  async getPlatformChanges(
    platformId: number | null,
  ): Promise<InterfacePlatformChange | null> {
    this.loader?.classList.add('active');
    try {
      const response = await fetch(
        `/api/platform-change/${platformId}`, {
          method: 'GET',
          headers: {
            'Authorization': 'true'
          },
        });
      const data: any = await response.json();
      this.loader?.classList.remove('active');
      return data;

    } catch (error) {
      this.loader?.classList.remove('active');

      return null;
    }
  }
}
